import { useEffect, useMemo } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { DEFAULT_GROUP_ROLE, DEFAULT_ORG_ROLE } from "Constants";
import { Group } from "Types";
import { MembersFormData, Organization } from "../../types";
import { generateMembersSchema } from "../../utils";

const useInviteForm = (currentOrganizationData?: Organization) => {
  const currentOrganizationGroups = currentOrganizationData?.groups;

  const defaultGroup: Group | undefined = useMemo(
    () => currentOrganizationGroups?.find((group) => group.is_default === true),
    [currentOrganizationGroups],
  );

  const initialGroupIds = useMemo(
    () => (defaultGroup ? [defaultGroup.group_id] : []),
    [defaultGroup],
  );

  const membersSchema = generateMembersSchema();

  const formMethods = useForm<MembersFormData>({
    resolver: yupResolver(membersSchema),
    defaultValues: {
      emails: [],
      orgGroups: initialGroupIds,
    },
    mode: "onChange",
  });

  const formReset = formMethods.reset;

  useEffect(() => {
    if (defaultGroup) {
      formReset({
        emails: [],
        orgGroups: [defaultGroup.group_id],
        orgRole: DEFAULT_ORG_ROLE,
        groupRole: DEFAULT_GROUP_ROLE,
      });
    }
  }, [defaultGroup, formReset]);

  return formMethods;
};

export default useInviteForm;
